/**
 * @generated SignedSource<<cad8f30b88a2ba0b562e84ff53e756eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isOpenSettingsAgents"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isOpenSettingsChannels"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isOpenSettingsOrganizationConfig"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isOpenSettingsProfile"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isOpenSettingsUsers"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initialRole",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wUserId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wAppId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wChannelId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationIcon",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationName",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v26 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "etag",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsModalRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isOpenSettingsAgents",
                "variableName": "isOpenSettingsAgents"
              },
              {
                "kind": "Variable",
                "name": "isOpenSettingsChannels",
                "variableName": "isOpenSettingsChannels"
              },
              {
                "kind": "Variable",
                "name": "isOpenSettingsOrganizationConfig",
                "variableName": "isOpenSettingsOrganizationConfig"
              },
              {
                "kind": "Variable",
                "name": "isOpenSettingsProfile",
                "variableName": "isOpenSettingsProfile"
              },
              {
                "kind": "Variable",
                "name": "isOpenSettingsUsers",
                "variableName": "isOpenSettingsUsers"
              }
            ],
            "kind": "FragmentSpread",
            "name": "SettingsModal_userViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SettingsModalRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fullName",
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "profilePicUrl",
                "storageKey": null
              },
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "App",
                "kind": "LinkedField",
                "name": "app",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "AppConnection",
                "kind": "LinkedField",
                "name": "appsPaginated",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "App",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "appsPaginated(first:30)"
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "SettingsOrganizationPage_appsPaginated",
                "kind": "LinkedHandle",
                "name": "appsPaginated"
              },
              {
                "condition": "isOpenSettingsUsers",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v21/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserEmail",
                        "kind": "LinkedField",
                        "name": "email",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "verified",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "profilePic",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Channel",
                        "kind": "LinkedField",
                        "name": "channels",
                        "plural": true,
                        "selections": [
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v16/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isOpenSettingsChannels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OutboundHook",
                        "kind": "LinkedField",
                        "name": "outboundHooks",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v25/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v26/*: any*/),
                    "concreteType": "ChannelConnection",
                    "kind": "LinkedField",
                    "name": "woztellChannels",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChannelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Channel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v16/*: any*/),
                              (v21/*: any*/),
                              (v27/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OutboundHook",
                                "kind": "LinkedField",
                                "name": "outboundHooks",
                                "plural": true,
                                "selections": [
                                  (v8/*: any*/),
                                  (v25/*: any*/),
                                  (v16/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasPreviousPage",
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startCursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "woztellChannels(first:10)"
                  },
                  {
                    "alias": null,
                    "args": (v26/*: any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "SettingsChannelsContainer_woztellChannels",
                    "kind": "LinkedHandle",
                    "name": "woztellChannels"
                  }
                ]
              },
              {
                "condition": "isOpenSettingsOrganizationConfig",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Integration",
                    "kind": "LinkedField",
                    "name": "folderActions",
                    "plural": true,
                    "selections": [
                      (v23/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "integrationId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "App",
                    "kind": "LinkedField",
                    "name": "app",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OutboundHook",
                        "kind": "LinkedField",
                        "name": "outboundHooks",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v25/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updatedAt",
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OutboundHookConfig",
                        "kind": "LinkedField",
                        "name": "outboundHookConfig",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stepTimeoutMs",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "chainTimeoutMs",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fetchAllowlistHosts",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoleBasedAppConfig",
                        "kind": "LinkedField",
                        "name": "roleBasedAppConfig",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "MASK_EXTERNALID",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChannelConfig",
                        "kind": "LinkedField",
                        "name": "defaultChannelConfig",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ChannelAutomationConfig",
                            "kind": "LinkedField",
                            "name": "automation",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "INBOX_AGENT_INTERNAL_COMMENT",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "INBOX_AGENT_MESSAGE",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "INBOX_ASSIGN_AGENT",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "INBOX_LIVECHAT_UPDATE",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "MOVE_THREAD_FOLDER",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleBasedConfig",
                            "kind": "LinkedField",
                            "name": "roleBasedConfig",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "SEND_MESSAGE_ALL",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "SEND_ATTACHMENT",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "SEND_AUDIO",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "TRANSFER_TO_UNASSOCIATED_FOLDERS",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ],
            "type": "UserScope",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ebd4e08f8d96f15cf27ecb409c0f55a5",
    "id": null,
    "metadata": {},
    "name": "SettingsModalRefetchQuery",
    "operationKind": "query",
    "text": "query SettingsModalRefetchQuery(\n  $isOpenSettingsAgents: Boolean!\n  $isOpenSettingsChannels: Boolean!\n  $isOpenSettingsOrganizationConfig: Boolean!\n  $isOpenSettingsProfile: Boolean!\n  $isOpenSettingsUsers: Boolean!\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...SettingsModal_userViewer_3mKSam\n    id\n  }\n}\n\nfragment SettingsAgentsContainer_userViewer_naICF on UserScope {\n  id\n}\n\nfragment SettingsChannelsContainer_userViewer on UserScope {\n  app {\n    id\n    wAppId\n    outboundHooks {\n      id\n      _id\n      name\n    }\n  }\n  woztellChannels(first: 10) {\n    edges {\n      node {\n        id\n        wChannelId\n        integrationIcon\n        integrationName\n        name\n        connected\n        etag\n        outboundHooks {\n          id\n          _id\n          name\n          etag\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      endCursor\n      startCursor\n    }\n  }\n  id\n}\n\nfragment SettingsModal_userViewer_3mKSam on UserScope {\n  email\n  fullName\n  firstName\n  lastName\n  profilePicUrl\n  role\n  initialRole\n  wUserId\n  app {\n    wAppId\n    name\n    id\n  }\n  ...SettingsAgentsContainer_userViewer_naICF @include(if: $isOpenSettingsAgents)\n  ...SettingsUsersContainer_userViewer @include(if: $isOpenSettingsUsers)\n  ...SettingsChannelsContainer_userViewer @include(if: $isOpenSettingsChannels)\n  ...SettingsProfileContainer_userViewer_naICF @include(if: $isOpenSettingsProfile)\n  ...SettingsOrganizationPage_userViewer\n  ...SettingsOrganizationConfig_userViewer @include(if: $isOpenSettingsOrganizationConfig)\n  id\n}\n\nfragment SettingsOrganizationConfig_userViewer on UserScope {\n  folderActions {\n    integrationIcon\n    integrationName\n    integrationId\n  }\n  app {\n    id\n    wAppId\n    outboundHooks {\n      id\n      _id\n      wAppId\n      name\n      description\n      code\n      createdAt\n      updatedAt\n      etag\n    }\n    outboundHookConfig {\n      stepTimeoutMs\n      chainTimeoutMs\n      fetchAllowlistHosts\n    }\n    roleBasedAppConfig {\n      MASK_EXTERNALID\n    }\n    defaultChannelConfig {\n      automation {\n        INBOX_AGENT_INTERNAL_COMMENT\n        INBOX_AGENT_MESSAGE\n        INBOX_ASSIGN_AGENT\n        INBOX_LIVECHAT_UPDATE\n        MOVE_THREAD_FOLDER\n      }\n      roleBasedConfig {\n        SEND_MESSAGE_ALL\n        SEND_ATTACHMENT\n        SEND_AUDIO\n        TRANSFER_TO_UNASSOCIATED_FOLDERS\n      }\n    }\n  }\n  id\n}\n\nfragment SettingsOrganizationPage_userViewer on UserScope {\n  appsPaginated(first: 30) {\n    edges {\n      node {\n        id\n        wAppId\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment SettingsProfileContainer_userViewer_naICF on UserScope {\n  id\n}\n\nfragment SettingsUsersContainer_userViewer on UserScope {\n  users {\n    wUserId\n    connected\n    email {\n      email\n      verified\n    }\n    profilePic\n    firstName\n    lastName\n    role\n    initialRole\n    channels {\n      wChannelId\n      integrationIcon\n      integrationName\n      name\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "f4a7764b3ba34f93b692bf3f15d80f41";

module.exports = node;
